<div
  *ngIf="!!localData.length && chartOption"
  echarts
  [options]="chartOption"
  [id]="chartId"
  (chartInit)="onChartInit($event)"
  class="custom-chart-container"
  style="height: 450px; width: 100%;"
></div>
